// src/components/Blocks/PeoplePreview/PeoplePreviewEdit.jsx
import React from 'react';
import PropTypes from 'prop-types';
import PeoplePreviewView from './PeoplePreviewView';

const PeoplePreviewEdit = ({
  data,
  onChangeBlock,
  selected,
  block,
  content,
}) => {
  return (
    <div>
      <PeoplePreviewView content={content} />
      <div
        style={{
          padding: '10px',
          backgroundColor: '#e3f2fd',
          marginTop: '10px',
          borderRadius: '4px',
          fontSize: '12px',
          color: '#1976d2',
          textAlign: 'center',
        }}
      >
        ℹ️ This is a read-only preview block. Content is automatically managed.
      </div>
    </div>
  );
};

PeoplePreviewEdit.propTypes = {
  data: PropTypes.object,
  onChangeBlock: PropTypes.func,
  selected: PropTypes.bool,
  block: PropTypes.string,
  content: PropTypes.object,
};

export default PeoplePreviewEdit;
